/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_ActiveInputs */

const en_highlight_settings_preview_active = /** @type {(inputs: Highlight_Settings_Preview_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`active`)
};

const es_highlight_settings_preview_active = /** @type {(inputs: Highlight_Settings_Preview_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activa`)
};

/**
* | output |
* | --- |
* | "active" |
*
* @param {Highlight_Settings_Preview_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_active = /** @type {((inputs?: Highlight_Settings_Preview_ActiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_ActiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_active(inputs)
	return en_highlight_settings_preview_active(inputs)
});